import React from 'react';
import { Button } from 'antd';
import settings from 'front-settings';

import styles from './Actions.module.scss';

const Actions = () => (
  <div className={styles.export}>
    <Button
      type="button"
      icon="download"
      href={`${settings.API_URL}/userrequest/export/csv/`}
    >
      Exporter les données brutes
    </Button>
  </div>
);

export default Actions;



// WEBPACK FOOTER //
// ./src/components/Agenda/Actions/index.js